import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timepicker"
export default class extends Controller {
  static targets = ["input"]

  openTimePicker() {
    if (this.inputTarget.showPicker) {
      this.inputTarget.showPicker()
      this.focus()
    }
  }

  focus() {
    this.inputTarget.focus()
  }
}
